import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UserSessionIdService } from '../services/user-session-id.service';

@Injectable()
export class UserSessionIdInterceptorService implements HttpInterceptor {
  readonly #userSessionIdSvc = inject(UserSessionIdService);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const id = this.#userSessionIdSvc.sessionId;

    if (!id) return next.handle(req);

    req = req.clone({
      setHeaders: {
        'session-id': id,
      },
    });

    return next.handle(req);
  }
}
